<span class="{{crossSell | crossSellBadge}}" title="{{crossSell | crossSellAbreviacao}}">
    <i *ngIf="isShowIcon" class="{{crossSell | crossSellIcon }}"></i>
    <span *ngIf="isShowAbreviacao" class="badge-text">{{crossSell | crossSellAbreviacao}}</span>
</span>